module.exports = function isFunction(x) {
  return typeof x === 'function';
};


//////////////////
// WEBPACK FOOTER
// /produit/nodejs/bin/node-v14.19.0-linux-x64/lib/~/tcomb/lib/isFunction.js
// module id = 30
// module chunks = 0